import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { pathNameKeygen, getItemFromPagination } from '../../actions'
import BetsList from './BetsList'
import RecommendationsList from './RecommendationsList'
import { smallTableBetsColumns } from '../../settings'
import './Recommender.css'

import get from 'lodash/get'

const HEADER_HEIGHT = 60;
const PLAYER_MENU_HEIGHT = 60;
const PAGE_PADDING_TOP = 20;
const PAGE_PADDING_BOTTOM = 60;
const TABLE_TITLE_HEIGHT = 20;

class RecommenderPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectedIdx: -1, pageTopOffset: 0, tableTopOffset: 0 }
  }

  componentDidMount() {
    const playerInfoBarHeight = document.getElementById('player-info-bar').clientHeight;
    this.setState({
      pageTopOffset: this.getPageTopOffset(playerInfoBarHeight),
      tableTopOffset: this.getTableTopOffset(playerInfoBarHeight)
    });
  }

  getPageTopOffset = playerInfoBarHeight => {
    return HEADER_HEIGHT + PLAYER_MENU_HEIGHT + playerInfoBarHeight;
  }

  getTableTopOffset = (playerInfoBarHeight) => {
    const pageTopOffset = this.getPageTopOffset(playerInfoBarHeight);
    return pageTopOffset + PAGE_PADDING_TOP + TABLE_TITLE_HEIGHT;
  }

  onBetClick = index => {
    this.setState({selectedIdx: index});
  }

  render() {
    const { bets, betEntities } = this.props;
    const { selectedIdx, pageTopOffset, tableTopOffset } = this.state;

    const selectedBet = getItemFromPagination(bets, betEntities, selectedIdx);
    const date = get(selectedBet, 'ticket.delivery_date');

    const stickyStyle = {'zIndex': '100', 'top': tableTopOffset}

    return (
      <div 
        className="recommender-page"
        style={{top: pageTopOffset}}>
        <div className="hbox hbox--vtop">
          <div className="bet-list hbox--flex">
            <h3 className="table-title">User bets on events</h3>
            <div 
              className="table-container"
              style={{height: window.innerHeight - tableTopOffset - PAGE_PADDING_BOTTOM}}>
              <BetsList 
                {...this.props}
                stickyStyle={stickyStyle}
                stickyTopOffset={0}
                columns={smallTableBetsColumns.map(col => ({...col, sortable: false}))}
                onRowClick={this.onBetClick}
                selected={selectedBet} />
            </div>
          </div>
          <div className="recomendations-list hbox--flex">
            <h3 className="table-title">
              System would recommend
            </h3>
            {date &&
              <div 
                className="table-container"
                style={{height: window.innerHeight - tableTopOffset - PAGE_PADDING_BOTTOM}}>
                <RecommendationsList {...this.props}
                  afterDate={moment(date).format('YYYY-MM-DDTHH:mm:ss')}
                  stickyStyle={stickyStyle}
                  stickyTopOffset={0}
                  keygen={({state, ownProps}) => {
                    const betId = get(selectedBet, 'id')
                    const location = state.routing.locationBeforeTransitions
                    return location ? `${location.pathname}/?bet_id=${betId}` : 'pathNameKeygen-unknown-location'
                  }} />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export const Recommender = connect(
  (state, ownProps) => {
    const { playerId } = ownProps.params;
    const key = pathNameKeygen({state, ownProps});

    const betEntities = get(state, 'entities.bets');
    const bets = get(state, ['pagination', 'bets', key]);
    
    return {
      playerId: playerId,
      player: state.entities.players[playerId],
      location: ownProps.location,
      bets,
      betEntities
    }
  },
  { }
)(RecommenderPage)


// WEBPACK FOOTER //
// ./src/components/Players/Recommender.js